module.exports = __webpack_public_path__ + "static/media/oilse.1d7dd9ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oilse.jpg
// module id = 5741
// module chunks = 0